// @flow

import { createAction } from 'redux-actions';

import { createPromiseAction } from 'utils/actionHelpers';

// Accounts

export const getAccounts = createAction('GET_ACCOUNTS');
export const getAccountsSuccess = createAction('GET_ACCOUNTS_SUCCESS');
export const getAccountsFailure = createAction('GET_ACCOUNTS_FAILURE');

// SYNC_SIDE_EFFECTS
export const syncDeletedAccount = createAction('SYNC_DELETED_ACCOUNT');

export const createAccount = createAction('CREATE_ACCOUNT');
export const createAccountSuccess = createAction('CREATE_ACCOUNT_SUCCESS');
export const createAccountFailure = createAction('CREATE_ACCOUNT_FAILURE');

export const updateAccount = createAction('UPDATE_ACCOUNT');
export const updateAccountSuccess = createAction('UPDATE_ACCOUNT_SUCCESS');
export const updateAccountFailure = createAction('UPDATE_ACCOUNT_FAILURE');

export const deleteAccount = createAction('DELETE_ACCOUNT');
export const deleteAccountSuccess = createAction('DELETE_ACCOUNT_SUCCESS');
export const deleteAccountFailure = createAction('DELETE_ACCOUNT_FAILURE');

export const upsertAccounts = createAction('UPSERT_ACCOUNTS', (payload) => payload, (payload, metadata) => metadata);
export const upsertAccountsSuccess = createAction('UPSERT_ACCOUNTS_SUCCESS');
export const upsertAccountsFailure = createAction('UPSERT_ACCOUNTS_FAILURE');

export const refreshAccounts = createAction('REFRESH_ACCOUNTS', (payload) => payload, (payload, meta) => meta);
export const refreshAccountsPrecheck = createAction('REFRESH_ACCOUNTS_PRECHECK');
export const refreshAccountsStatuses = createAction('REFRESH_ACCOUNTS_STATUSES');
export const refreshAccountsCompleted = createAction('REFRESH_ACCOUNTS_COMPLETED', (payload) => payload, (payload, meta) => meta);

export const refreshAccountsTriggeredMfa = createAction('REFRESH_ACCOUNTS_TRIGGERED_MFA');

export const refreshAccountsMfaFormSubmit = createPromiseAction('REFRESH_ACCOUNTS_MFA_FORM_SUBMIT');
export const refreshAccountsMfaFormSubmitResponse = createAction('REFRESH_ACCOUNTS_MFA_FORM_SUBMIT_RESPONSE');
export const refreshAccountsMfaNotProvided = createAction('REFRESH_ACCOUNTS_MFA_NOT_PROVIDED');

// Investment Accounts

export const getInvestmentAccounts = createAction('GET_INVESTMENT_ACCOUNTS');
export const getInvestmentAccountsSuccess = createAction('GET_INVESTMENT_ACCOUNTS_SUCCESS');
export const getInvestmentAccountsFailure = createAction('GET_INVESTMENT_ACCOUNTS_FAILURE');

export const createInvestmentAccount = createAction('CREATE_INVESTMENT_ACCOUNT');
export const createInvestmentAccountSuccess = createAction('CREATE_INVESTMENT_ACCOUNT_SUCCESS');
export const createInvestmentAccountFailure = createAction('CREATE_INVESTMENT_ACCOUNT_FAILURE');

export const updateInvestmentAccount = createAction('UPDATE_INVESTMENT_ACCOUNT');
export const updateInvestmentAccountSuccess = createAction('UPDATE_INVESTMENT_ACCOUNT_SUCCESS');
export const updateInvestmentAccountFailure = createAction('UPDATE_INVESTMENT_ACCOUNT_FAILURE');

export const updateInvestmentAccountBalances = createAction('UPDATE_INVESTMENT_ACCOUNT_BALANCES');

export const upsertInvestmentAccounts = createAction('UPSERT_INVESTMENT_ACCOUNTS', (payload) => payload, (payload, metadata) => metadata);
export const upsertInvestmentAccountsSuccess = createAction('UPSERT_INVESTMENT_ACCOUNTS_SUCCESS');
export const upsertInvestmentAccountsFailure = createAction('UPSERT_INVESTMENT_ACCOUNTS_FAILURE');

export const deleteInvestmentAccount = createAction('DELETE_INVESTMENT_ACCOUNT');
export const deleteInvestmentAccountSuccess = createAction('DELETE_INVESTMENT_ACCOUNT_SUCCESS');
export const deleteInvestmentAccountFailure = createAction('DELETE_INVESTMENT_ACCOUNT_FAILURE');
